import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '@/store/auth.store';

interface RequireAnyPermissionProps {
  permissions: Array<[string, string]>;
  children: ReactNode;
  /**
   * Rendered when no permission in the list is held. Defaults to <Navigate to="/403" replace />.
   * Callers should ensure a /403 route exists in App.tsx or supply a custom fallback.
   */
  fallback?: ReactNode;
}

/**
 * Renders children if the current user holds ANY of the listed (module, action) pairs.
 * Platform admins always pass. Missing tenant context is treated as permission denied.
 */
export function RequireAnyPermission({ permissions, children, fallback }: RequireAnyPermissionProps) {
  const permitted = permissions.some(([mod, action]) => hasPermission(mod, action));
  if (!permitted) {
    return fallback !== undefined ? <>{fallback}</> : <Navigate to="/403" replace />;
  }
  return <>{children}</>;
}
